import React, { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetHomeWorkLists } from "../../StateManagement/Reducers/HomeWorkState";
import TopNav from "../TopNav";
import DocumentView from "./DocumentView";
import VideoView from "./VideoView";
import Pagination from "../StyledComponents/Pagination";
import Loading from "../StyledComponents/Loading";
import ListView from "./ListView";
import GridView from "./GridView";
import { Select } from "antd";
import { BodyContainer, Modal } from "../StyledComponents";
import {
  Flexbetween,
  FlexCenter,
  IconStyle,
  InputBox,
  Label,
  ViewFlexBox,
  FilterSelect,
} from "./Styles";
import { BsListUl, BsGrid } from "react-icons/bs";

const HomeWork = () => {
  const dispatch = useDispatch();
  //--------------------------------- State Start ---------------------------------//

  const [myState, setMyState] = useState({
    view: "Grid",
    listIs: false,
    gridIs: true,
    show: false,
    showdoc: false,
    url: "",
    docTitle: "",
    search: "",
    watchedId: null,
  });
  const [filterType, setFilterType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [url, setUrl] = useState("");
  const [docTitle, setDocTitle] = useState("");
  const [watchedId, setWatchedId] = useState(null);
  const DocumentsList = useSelector((state) => state.HomeWork.HomeWorkList);
  console.log("DocumentsList:", DocumentsList);
  const LoadingIS = useSelector((state) => state.HomeWork.Loading);

  const filteredData = DocumentsList.filter((item) => {
    const matchesSearch =
      myState.search === "" ||
      item.title?.toLowerCase().includes(myState.search.toLowerCase());

    const matchesType = filterType === "" || item.fileType === filterType;

    return matchesSearch && matchesType;
  });

  const width = window.innerWidth;
  const height = window.innerHeight;

  const RoundHeight = parseInt((height - 150) / 443);

  const calc = ((width - 330) / 360) * RoundHeight;

  const RoundCalc = parseInt(calc);

  const indexOfLastPost = currentPage * RoundCalc;
  const indexOfFirstPost = indexOfLastPost - RoundCalc;
  // const currentPosts = DocumentsList.slice(indexOfFirstPost, indexOfLastPost);
  const currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost);
  // const howManyPages = Math.ceil(DocumentsList.length / RoundCalc);
  const howManyPages = Math.ceil(filteredData.length / RoundCalc);

  const indexOfLastList = currentPage * (RoundCalc * 2);
  const indexOfFirstList = indexOfLastList - RoundCalc * 2;
  // const currentPostsList = DocumentsList.slice(
  //   indexOfFirstList,
  //   indexOfLastList,
  // );
  const currentPostsList = filteredData.slice(
    indexOfFirstList,
    indexOfLastList,
  );
  // const howManyPagesList = Math.ceil(DocumentsList.length / (RoundCalc * 2));
  const howManyPagesList = Math.ceil(filteredData.length / (RoundCalc * 2));
  //---------------------------------- State End ----------------------------------//

  //----------------------------- Functionality Start -----------------------------//

  const handleChange = (value) => {
    dispatch(GetHomeWorkLists(value));
  };

  const optimizedFn = useCallback(debounce(handleChange), []);

  const handleOpen = (item) => {
    setUrl(item.fileUrl);
    setDocTitle(item.title);
    setWatchedId(item.id);
    if (item.fileType === "Video") {
      setMyState({ ...myState, show: true, showdoc: false });
    } else if (item.fileType === "Worksheet") {
      setMyState({ ...myState, show: false, showdoc: true });
    }
  };

  //----------------------------- Functionality End -----------------------------//

  //------------------------------ UseEffectt Start ------------------------------//

  useEffect(() => {
    dispatch(GetHomeWorkLists(""));
  }, []);

  //------------------------------ UseEffectt End ------------------------------//

  return (
    <>
      <TopNav title="Home Work" />
      <BodyContainer paddingLeft="12px" paddingTop="4px" paddingBottom="10px">
        <div
          style={{
            background: "#2E2E2E1A",
            padding: "6px 12px",
            borderRadius: "6px",
            marginBottom: "5px",
          }}
        >
          <Flexbetween margin="6px 16px 6px 16px">
            <FlexCenter>
              <Label color="#718096">Title / Description / Notes / Tag:</Label>
              <InputBox
                placeholder="Search"
                value={myState.search}
                onChange={(e) => {
                  setMyState({ ...myState, search: e.target.value });
                  optimizedFn(e.target.value);
                }}
              />
              <FilterSelect
                placeholder="Filter by Type"
                style={{ width: 150, marginLeft: "12px", height: "34px" }}
                value={filterType || undefined}
                onChange={(value) => {
                  setFilterType(value || "");
                  setCurrentPage(1);
                }}
                allowClear
              >
                <Select.Option value="Video">Video</Select.Option>
                <Select.Option value="Worksheet">Worksheet</Select.Option>
              </FilterSelect>
            </FlexCenter>
            <ViewFlexBox>
              <IconStyle
                active={myState.gridIs}
                onClick={() => {
                  setMyState({
                    ...myState,
                    listIs: false,
                    gridIs: true,
                    view: "Grid",
                  });
                }}
              >
                <BsGrid />
                <Label>Grid</Label>
              </IconStyle>
              <IconStyle
                active={myState.listIs}
                onClick={() => {
                  setMyState({
                    ...myState,
                    listIs: true,
                    gridIs: false,
                    view: "List",
                  });
                }}
              >
                <BsListUl />
                <Label>List</Label>
              </IconStyle>
            </ViewFlexBox>
          </Flexbetween>
        </div>
        <div
          style={{
            background: "#FFFFFF",
            borderRadius: "12px",
            minHeight: "550px",
            overflow: "hidden",
          }}
        >
          {LoadingIS ? (
            <Loading />
          ) : (
            <>
              <div style={{ padding: "0px" }}>
                {myState.view === "List" ? (
                  <>
                    <ListView
                      data={currentPostsList}
                      setMyState={setMyState}
                      handleOpen={handleOpen}
                    />
                    {(currentPostsList.length !== 0 ||
                      howManyPagesList >= 1) && (
                      <Pagination
                        pages={howManyPagesList}
                        setCurrentPage={setCurrentPage}
                        view={myState.view}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <GridView
                      data={currentPosts}
                      setMyState={setMyState}
                      handleOpen={handleOpen}
                      size={RoundCalc}
                    />
                    {(currentPosts.length !== 0 || howManyPages > 1) && (
                      <Pagination
                        pages={howManyPages}
                        setCurrentPage={setCurrentPage}
                        view={myState.view}
                      />
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </BodyContainer>

      {myState.show && (
        <Modal width="100%" height="100%" show={myState.show}>
          <VideoView
            myState={myState}
            setMyState={setMyState}
            url={url}
            clearId={setWatchedId}
            id={watchedId}
          />
        </Modal>
      )}

      {myState.showdoc && (
        <Modal width="100%" height="100%" show={myState.showdoc}>
          <DocumentView
            myState={myState}
            setMyState={setMyState}
            url={url}
            docTitle={docTitle}
            clearId={setWatchedId}
            id={watchedId}
          />
        </Modal>
      )}
    </>
  );
};

export default HomeWork;

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 1000);
  };
};
